module.exports = __webpack_public_path__ + "img/t2-20.5b2c1944.svg";